// old modification

// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function GroupMaster() {
//   const [groups, setGroups] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [recordsPerPage, setRecordsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [deleteCode, setDeleteCode] = useState(null);

//   const apiUrl = "http://localhost:5000/api/groups";
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Fetch groups from server
//   const fetchGroups = async () => {
//     setLoading(true);
//     try {
//       const resp = await fetch(
//         `${apiUrl}?page=${currentPage}&limit=${recordsPerPage}&search=${searchQuery}`
//       );
//       if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
//       const json = await resp.json();
//       const arr = json.data || [];
//       setGroups(arr);
//       setTotalPages(json.pagination?.totalPages || 1);
//     } catch (err) {
//       console.error("Fetch groups error:", err);
//       toast.error("Failed to fetch groups.");
//       setGroups([]);
//       setTotalPages(1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Initial fetch and when page/recordsPerPage/searchQuery changes
//   useEffect(() => {
//     fetchGroups();
//   }, [currentPage, recordsPerPage, searchQuery]);

//   // Refresh if navigated back after edit
//   useEffect(() => {
//     if (location.state?.updated) {
//       fetchGroups();
//       toast.success("Table updated with latest data!");
//     }
//   }, [location.state]);

//   // Delete confirm
//   const confirmDelete = (groupCode) => {
//     setDeleteCode(groupCode);
//   };

//   // Delete handler
//   const handleDelete = async () => {
//     if (!deleteCode) return;

//     try {
//       const response = await fetch(`${apiUrl}/delete/${deleteCode}`, {
//         method: "DELETE",
//         headers: { "Content-Type": "application/json" },
//       });
//       const result = await response.json();

//       if (response.ok) {
//         toast.success(result.message || "Group deleted successfully!");
//         fetchGroups(); // Refresh page after deletion
//       } else {
//         toast.error(result.error || "Cannot delete this group");
//       }
//     } catch (err) {
//       console.error("Delete Error:", err);
//       toast.error("Network error while deleting.");
//     } finally {
//       setDeleteCode(null);
//     }
//   };

//   // Edit handler
//   const handleEdit = (group) => {
//     if (group.GroupCODE < 29) {
//       toast.warning("Cannot edit group with code < 29");
//       return;
//     }
//     navigate("/UpdateGroup", { state: { groupData: group } });
//   };

//   return (
//     <div className="Payment_div">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="payment_maintext">
//         <h6>Group Master</h6>
//         <div>
//           <Link className="payment_breadcrumbs" to={"/groupmaster"}>
//             <p>Group Master</p>
//           </Link>
//           <span>
//             <i className="fa-solid fa-chevron-right"></i> Master
//           </span>
//         </div>
//       </div>

//       <div className="button_search-payment">
//         <Link to={"/AddGroup"}>
//           <button type="button" className="btn btn">
//             <i className="fa-solid fa-plus"></i> Add Group
//           </button>
//         </Link>

//         <div className="search-input_box">
//           <input
//             type="search"
//             className="form-control"
//             placeholder="Search for group..."
//             value={searchQuery}
//             onChange={(e) => {
//               setSearchQuery(e.target.value);
//               setCurrentPage(1); // reset to page 1 when search changes
//             }}
//           />
//         </div>
//       </div>

//       <div className="search-container mt-3">
//         <div className="records-per-page-container">
//           <label htmlFor="recordsPerPage">Records Per Page:</label>
//           <select
//             id="recordsPerPage"
//             value={recordsPerPage}
//             onChange={(e) => {
//               setRecordsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={5}>5</option>
//             <option value={10}>10</option>
//             <option value={15}>15</option>
//             <option value={20}>20</option>
//           </select>
//         </div>
//       </div>

//       <div className="vehicle-type-container mb-5">
//         {loading && <p>Loading...</p>}
//         {!loading && groups.length === 0 && <p>No groups found.</p>}

//         {!loading && groups.length > 0 && (
//           <div className="response-container w-2/4">
//             <div className="table-wrapper" style={{ overflowX: "auto" }}>
//               <table className="data-table">
//                 <thead>
//                   <tr>
//                     <th>Group Name</th>
//                     <th>Under Group</th>
//                     <th className="w-14">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {groups.map((item, idx) => (
//                     <tr key={idx}>
//                       <td>{item.GroupNAME}</td>
//                       <td>{item.MainGroupName || "-"}</td>
//                       <td>
//                         <div className="seletdata_edit-delet-btn">
//                           <button
//                             className="selet_edit-btn"
//                             title="Edit"
//                             onClick={() => handleEdit(item)}
//                           >
//                             <i className="fa-solid fa-pen-to-square"></i>
//                           </button>
//                           <button
//                             className="select_delete-btn"
//                             data-bs-toggle="modal"
//                             data-bs-target="#deleteConfirmationModal"
//                             onClick={() => confirmDelete(item.GroupCODE)}
//                           >
//                             <i className="fa-solid fa-trash"></i>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination Controls */}
//             <div
//               className="select_pagination mt-4"
//               style={{
//                 textAlign: "center",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 gap: "10px",
//               }}
//             >
//               <button
//                 onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//                 disabled={currentPage === 1}
//                 style={{
//                   padding: "6px 12px",
//                   fontSize: "14px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: "12px",}}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   padding: "6px 12px",
//                   fontSize: "12px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Delete Confirmation Modal */}
//         <div className="modal fade" id="deleteConfirmationModal">
//           <div className="modal-dialog modal-dialog-centered">
//             <div className="modal-content">
//               <div className="close_topbutton-taxes">
//                 <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
//               </div>
//               <div className="delet_icon-boxtaxes">
//                 <i className="fa-solid fa-trash"></i>
//               </div>
//               <div className="taxes_pcolom">
//                 <h6>Confirm Delete</h6>
//                 <p>Are you sure you want to delete?</p>
//               </div>
//               <div className="close_bottombutton-taxes">
//                 <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="delete_button"
//                   data-bs-dismiss="modal"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default GroupMaster;

//New Modification code
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";
import DeleteConfirmModal from "../../../Component/DeleteModal/DeleteConfirmModal";
import { MasterTableSkeleton } from "../../../Component/Skeleton";
import "../Ledger/ShowLedger.css";

function GroupMaster() {
  const [groups, setGroups] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [deleteCode, setDeleteCode] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
  const apiUrl = `${BASE_API_URL}/groups`;
  const navigate = useNavigate();
  const location = useLocation();

  // Fetch groups from backend with search
  const fetchGroups = async () => {
    setLoading(true);

    try {
      const resp = await fetch(
        `${apiUrl}?page=${currentPage}&limit=${recordsPerPage}&search=${encodeURIComponent(
          searchQuery
        )}`
      );

      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const json = await resp.json();

      const arr = json.data || [];
      setGroups(arr);
      setTotalPages(json.pagination?.totalPages || 1);
    } catch (err) {
      console.error("Fetch groups error:", err);
      showToast.error("Failed to fetch groups.");
      setGroups([]);
      setTotalPages(1);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data whenever pagination or search query changes
  useEffect(() => {
    fetchGroups();
  }, [currentPage, recordsPerPage, searchQuery]);

  // Refresh table if navigated back after edit
  useEffect(() => {
    if (location.state?.updated) {
      fetchGroups();
      showToast.save("Table updated with latest data!");
    }
  }, [location.state]);

  // Confirm delete
  const confirmDelete = (item) => {
    if (item.GroupCODE < 29) {
      showToast.warn("System group cannot be deleted.");
      return;
    }
    setDeleteCode(item.GroupCODE);
    setDeleteItemName(item.GroupNAME || `Group #${item.GroupCODE}`);
    setDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    if (isDeleting) return;
    if (!deleteCode) return;

    try {
      setIsDeleting(true);
      const res = await apiWithLog({
        method: "DELETE",
        url: `${apiUrl}/delete/${deleteCode}`,
        module: "GroupMaster",
        action: "D",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data || {};

      if (res.status >= 200 && res.status < 300) {
        showToast.delete(result.message || "Group deleted successfully!");
        setDeleteModalOpen(false);
        fetchGroups();
      } else {
        showToast.error(result.error || "Cannot delete this group");
      }
    } catch (err) {
      console.error("Delete Error:", err);
      showToast.error("Network error while deleting.");
    } finally {
      setIsDeleting(false);
      setDeleteCode(null);
    }
  };

  // Handle edit
  const handleEdit = (group) => {
    if (group.GroupCODE < 29) {
      showToast.warn("You cannot edit system default group.");
      return;
    }
    navigate("/UpdateGroup", { state: { groupData: group } });
  };

  return (
    <div className="ledger_page_container">
      {/* HEADER & BREADCRUMBS */}
      <div className="ledger_header_bar">
        <div className="ledger_header_title_group">
          <h4 className="ledger_header_title">Group Master</h4>
          <div className="ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <span>Master</span>
            <span>/</span>
            <span>Group Master</span>
          </div>
        </div>
      </div>

      {/* TOP CONTROLS */}
      <div className="ledger_top_controls">
        <div className="ledger_top_left">
          <Link to="/AddGroup" className="new_ledger_btn">
            + Add Group Master
          </Link>
        </div>

        <div className="ledger_top_right">
          <div className="ledger_search_box">
            <input
              type="search"
              className="ledger_search_input"
              placeholder="Search groups..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>

          <div className="ledger_records_select_group">
            <label htmlFor="recordsPerPage">Show:</label>
            <select
              id="recordsPerPage"
              className="ledger_records_select"
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </div>

      {/* TABLE CARD */}
      <div className="ledger_table_section">
        {loading && (
          <MasterTableSkeleton columns={3} rows={6} hasToolbar={false} />
        )}

        {!loading && groups.length > 0 && (
          <>
            <div className="ledger_table_wrapper">
              <table className="ledger_table">
                <thead>
                  <tr>
                    <th>Group Name</th>
                    <th>Main Group</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {groups.map((item, idx) => (
                    <tr key={item.GroupCODE || idx}>
                      <td className="ledger_name_cell">{item.GroupNAME}</td>
                      <td>{item.MainGroupName || "-"}</td>
                      <td className="ledger_actions_cell">
                        <button
                          type="button"
                          className="ledger_btn_edit"
                          title="Edit Group"
                          onClick={() => handleEdit(item)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                        <button
                          type="button"
                          className="ledger_btn_delete"
                          title="Delete Group"
                          onClick={() => confirmDelete(item)}
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* PAGINATION SECTION */}
            <div className="ledger_pagination_container">
              <div className="ledger_pagination_info">
                Page {currentPage} of {totalPages}
              </div>

              <div className="ledger_pagination_controls">
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="ledger_page_badge">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}

        {!loading && groups.length === 0 && (
          <div className="ledger_empty_state">
            <h6>No Groups Found</h6>
            <p>
              {searchQuery
                ? `No groups matching "${searchQuery}"`
                : "No groups configured. Click '+ Add Group Master' to add one."}
            </p>
          </div>
        )}
      </div>

      {/* Reusable Custom Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDelete}
        title="Delete Group Master?"
        message="Are you sure you want to delete this group? All ledgers under it may be affected."
        itemName={deleteItemName}
        loading={isDeleting}
      />
    </div>
  );
}

export default GroupMaster;
